module.exports = __webpack_public_path__ + "static/pki_horizontal-5d61679876f2af98d46858c08d2f5ed0.png";